import React from "react";
import {
    OutsourcePanel,
    OutsourcePanelTitle,
    SummaryLine,
    SummaryLineLabel,
    SummaryLineValue,
    SummaryRows,
} from "../../components";
import { formatCurrency } from "../../../../utils/format";
import { Divider } from "@mui/material";
import { calculateProviderValue } from "../../utils";

interface SummaryProps {
    data: any[];
    undetermined?: boolean;
}

const Summary = ({ data = [], undetermined = false }: SummaryProps) => {
    const totalPrice = calculateProviderValue(data);

    return (
        <OutsourcePanel>
            <OutsourcePanelTitle>Tổng đơn hàng</OutsourcePanelTitle>
            <SummaryRows>
                <SummaryLine>
                    <SummaryLineLabel title={`Giá gia công (${data.length} vật tư)`}>
                        Giá gia công ({data.length} vật tư)
                    </SummaryLineLabel>
                    <SummaryLineValue>{undetermined ? "Chưa xác định" : formatCurrency(totalPrice)}</SummaryLineValue>
                </SummaryLine>
            </SummaryRows>
            <Divider />
            <SummaryRows>
                <SummaryLine $strong>
                    <SummaryLineLabel>Tổng đơn hàng</SummaryLineLabel>
                    <SummaryLineValue>{undetermined ? "Chưa xác định" : formatCurrency(totalPrice)}</SummaryLineValue>
                </SummaryLine>
            </SummaryRows>
        </OutsourcePanel>
    );
};

export default Summary;
